import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { FullCalendarModule } from '@fullcalendar/angular';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

/**
 * Compatibility shim: wraps third-party NgModules compiled against Angular ≤18
 * so they can be consumed via importProvidersFrom() in the v21 standalone bootstrap.
 */
@NgModule({
  imports: [
    NgbModule,
    LoadingBarRouterModule,
    MatDialogModule,
    FullCalendarModule,
    BsDropdownModule,
    NgxIntlTelInputModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      progressBar: false,
      enableHtml: true,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    NgbModule,
    LoadingBarRouterModule,
    MatDialogModule,
    FullCalendarModule,
    BsDropdownModule,
    NgxIntlTelInputModule,
    ToastrModule,
    TranslateModule,
  ],
})
export class ThirdPartyCompatModule {}
